module.exports = __webpack_public_path__ + "cd455783/img/file-icon.c085e21e.svg";